var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1333_23947)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39514 14C11.2611 14 14.3951 10.866 14.3951 7C14.3951 3.13401 11.2611 0 7.39514 0C3.52915 0 0.395142 3.13401 0.395142 7C0.395142 10.866 3.52915 14 7.39514 14Z",
    fill: "#81888E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39058 4.66361C7.81786 4.66361 8.1724 4.31816 8.1724 3.88179C8.1724 3.45452 7.81786 3.09998 7.39058 3.09998C6.96331 3.09998 6.60876 3.45452 6.60876 3.88179C6.60876 4.31816 6.96331 4.66361 7.39058 4.66361ZM6.75422 9.99998H8.03604V5.30907H6.75422V9.99998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1333_23947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3073,
    height: 14,
    fill: "white",
    transform: "translate(0.395142)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4c589a9213f0fa2983835e392f8f761f.svg";
export { ForwardRef as ReactComponent };